import AppAssets from "@toothfairy/shared-ui/AppAssets";
import { AppText } from "@toothfairy/shared-ui";
import AppPlaceholderView from "@toothfairy/shared-ui/AppPlaceholderView";
import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import { useHistory } from "../../Router";
import React, { useEffect } from "react";
import { View } from "react-native";

const AccessDeniedScreen = () => {
  const { currentTheme } = AppTheme.useTheme();
  const { dispatch } = AppStateManager.useAppStateManager();
  const history = useHistory();
  return (
    <View
      style={{
        width: "50%",
        height: "50%",
        marginVertical: "auto",
        marginHorizontal: "auto",

        alignItems: "center",
      }}
    >
      <AppPlaceholderView
        wrapperStyle={{
          height: "auto",
          paddingBottom: 20,
        }}
        size={30}
        color={currentTheme?.theme?.red}
        icon={AppAssets.icons.accessDenied}
        mainCaption="You don't have access to this page"
        mainCaptionStyle={{
          fontSize: currentTheme?.theme?.large_font_size,
        }}
      />
      <AppText
        isClickable
        isHoverable={false}
        style={{
          textDecoration: "underline",
          color: currentTheme?.theme?.primary,
          fontFamily: "boldFont",
        }}
        onPress={() => {
          dispatch("SET_PAGE_NOT_FOUND", false);
          history.push("/workspaces");
        }}
      >
        Workspaces selection page
      </AppText>
    </View>
  );
};

export default AccessDeniedScreen;
